var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('PageHero'),_c('AboutusInfo'),_c('Accomplishments'),_c('Reasons'),_c('Staff'),_c('CtaSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }